module.exports = __webpack_public_path__ + "img/wm-system.4bd3e809.jpg";